export type PaymentCondition = {
    paymentMethod: PaymentMethod;
    installmentOptions: InstallmentOption[];
    tastingPeriodDays?: number;
    tastingPeriod?: TastingPeriod;
    installment?: number;
    metadata?: Record<string, unknown>;
};

export enum PaymentMethod {
    PIX = 'pix',
    CREDIT_CARD = 'credit_card',
}

export type InstallmentOption = {
    installment: number;
    amount: number;
    discount: number;
    originalAmount: number;
    discountCategory?: string;
    discountType?: string;
    discountNumberOfCycles?: number;
    metadata?: Record<string, unknown>;
};

export type TastingPeriod = {
    duration: number;
    price: number;
    url?: string;
    endDate?: string;
    metadata?: Record<string, unknown>;
};
